import { Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';

type VATLineProps = {
  calculateVATPercentage: (taxAmount: number | undefined, totalAmount: number) => string;
  currency: string;
  formatPrice: (amount: number, currency: string) => string;
  taxAmount?: number;
  totalAmount: number;
};

export const VATLine = ({ calculateVATPercentage, currency, formatPrice, taxAmount, totalAmount }: VATLineProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Stack alignItems="center" direction="row" justifyContent="space-between">
      <Typography color="grey.700" variant="body-2">
        {t('billing.confirm.vat', { percent: calculateVATPercentage(taxAmount, totalAmount) })}
      </Typography>
      <Typography color="grey.700" variant="body-2">
        {formatPrice(taxAmount ?? 0, currency)}
      </Typography>
    </Stack>
  );
};
